import lfRequest from '@/service/index'

enum ResourceAnalysisApi {
  telephoneFrequency = '/main/resourceAnalysis/telephoneFrequency',
  resourceTrans = '/main/resourceAnalysis/resourceTrans',
  resourceChat = '/main/resourceAnalysis/resourceChat',
  lotteryData = '/main/resourceAnalysis/lotteryData',
  liveFuboData = '/main/resourceAnalysis/liveFuboData',
  activateData = '/main/resourceAnalysis/activateData',
  liveFuboDealData='/main/resourceAnalysis/liveFuboDealData'
}
export function queryResourceStatisticsInfo(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/main/resourceAnalysis/queryResourceStatisticsInfo',
    params:queryInfo
  })
}
export function getTelephoneFrequency(queryInfo: any) {
  return lfRequest.get<any>({
    url: ResourceAnalysisApi.telephoneFrequency,
    params:queryInfo
  })
}
export function getresourceTrans(queryInfo: any) {
  return lfRequest.get<any>({
    url: ResourceAnalysisApi.resourceTrans,
    params: queryInfo
  })
}
export function getResourceChat(queryInfo: any) {
  return lfRequest.get<any>({
    url: ResourceAnalysisApi.resourceChat,
    params:queryInfo
  })
}
export function getLotteryData(queryInfo: any) {
  return lfRequest.get<any>({
    url: ResourceAnalysisApi.lotteryData,
    params:queryInfo
  })
}
export function getLiveFuboData(queryInfo: any) {
  return lfRequest.get<any>({
    url: ResourceAnalysisApi.liveFuboData,
    params:queryInfo
  })
}
export function getActivateData(queryInfo: any) {
  return lfRequest.get<any>({
    url: ResourceAnalysisApi.activateData,
    params:queryInfo
  })
}
export function getliveFuboDealData(queryInfo: any) {
  return lfRequest.get<any>({
    url: ResourceAnalysisApi.liveFuboDealData,
    params:queryInfo
  })
}



